import { render, staticRenderFns } from "./view-amazon-order.vue?vue&type=template&id=7e5e248a&lang=pug&"
import script from "./view-amazon-order.vue?vue&type=script&lang=js&"
export * from "./view-amazon-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports